import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';
import Locale from '../../Locales/ts/Locale';

export const actions: ActionTree<any, any> = {

    getSettings: ({state, getters, commit, dispatch}, force) => {

        if (force) commit('bustSettingsCache');

        // Pull from store if loaded and cache hasn't expired
        if (state.settingsExpire && moment().isBefore(state.settingsExpire)) {
            return state.settings;
        }

        commit('setSettingsLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/panel')

                .then(({data}) => {
                    commit('saveSettings', data.settings);
                    commit('setSettingsLoading', false);
                    resolve(null);
                })
                .catch(error => {
                    commit('setSettingsLoading', false);
                    reject(error);
                });
        });
    },

    saveSettings: ({state, getters, commit, dispatch}, form) => {

        commit('setSettingsSaving', true);

        return new Promise((resolve, reject) => {

            form.send('put', '/panel')

                .then((response: AxiosResponse) => {
                    commit('saveSettings', response.data.settings);
                    commit('setSettingsSaving', false);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('setSettingsSaving', false);
                    reject(error);
                });
        });
    },

    enableLocale: ({state, getters, commit, dispatch}, locale) => {

        commit('enableLocale', locale);

        return new Promise((resolve, reject) => {
            dispatch('updateLocales')
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    commit('disableLocale', locale);
                    reject(error);
                });
        });
    },

    disableLocale: ({state, getters, commit, dispatch}, locale) => {

        commit('disableLocale', locale);

        return new Promise((resolve, reject) => {
            dispatch('updateLocales')
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    commit('enableLocale', locale);
                    reject(error);
                });
        });
    },

    updateLocales: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            const localeIds = state.settings.locales.map((locale: Locale) => locale.id);

            axios.put('/panel/locales', {locales: localeIds})

                .then((response: AxiosResponse) => {

                    dispatch('updateLocaleDataVariable', null, {root: true})
                        .then((response: AxiosResponse) => {
                            resolve(null);
                        })
                        .catch((error: AxiosError) => {
                            reject(error);
                        });
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getApiClients: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            axios.get('/panel/api-clients')
                .then(response => {
                    commit('setApiClients', response.data.clients);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

    createApiClient: ({state, getters, commit, dispatch}, payload) => {

        return new Promise((resolve, reject) => {

            axios.put('/panel/api-clients', payload)
                .then(response => {
                    commit('addApiClient', response.data.client);
                    resolve(response)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

    deleteApiClient: ({state, getters, commit, dispatch}, id: Number) => {

        const apiClients = [...state.apiClients];

        commit('deleteApiClient', id);

        return new Promise((resolve, reject) => {

            axios.delete('/panel/api-clients/' + id)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    commit('setApiClients', apiClients);
                    reject(error);
                })
        });
    },

    getIntegrations: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            axios.get('/panel/integrations')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

    saveIntegrationSettings: ({state, getters, commit, dispatch}, payload) => {

        return new Promise((resolve, reject) => {

            axios.post('/panel/integrations', payload)
                .then(response => {
                    commit('saveIntegrations', response.data.integrations);
                    resolve(response)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

};
